import { render, staticRenderFns } from "./RoyaltyAccounting.vue?vue&type=template&id=d11a1c78&scoped=true&"
import script from "./RoyaltyAccounting.vue?vue&type=script&lang=js&"
export * from "./RoyaltyAccounting.vue?vue&type=script&lang=js&"
import style0 from "./RoyaltyAccounting.vue?vue&type=style&index=0&id=d11a1c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11a1c78",
  null
  
)

export default component.exports